import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Hospital } from 'src/app/models/hospital.interface';

import { Nivel } from 'src/app/models/nivel.interface';
import { Especialidad } from 'src/app/models/especialidad.interface';
import { Catalogo, Puntos } from 'src/app/models/catalogos.interface';
import { TipoDropdown } from 'src/app/models/tipo-dropdown.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
import { Institucion } from 'src/app/models/institucion.interface';
import { Estado } from 'src/app/models/estado.interface';

@Component({
  selector: 'app-administrador-usuario-nuevo',
  templateUrl: './administrador-usuario-nuevo.component.html',
  styleUrls: ['./administrador-usuario-nuevo.component.scss'],
  providers: [MessageService]
})
export class AdministradorUsuarioNuevoComponent implements OnInit {

  formUsuario: FormGroup;
  hospitales: Hospital[] = [];
  especialidades: Especialidad[] = [];

  puestos: Catalogo[] = [];
  instituciones: TipoDropdown[] = [];
  estados: TipoDropdown[] = [];
  roles: Catalogo[] = [];
  niveles: Catalogo[] = [];
  puntos: TipoDropdown[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private messageService: MessageService,
    private administradorService: AdministradorService
  ) {
    this.formUsuario = this.createUsuarioFormulario();
    this.obtenerInformacion();
    this.confiChange();
  }
  ngOnInit(): void { }

  onSubmit(): void {
    if (this.formUsuario.valid) {
      //  console.log('Formulario enviado:', this.formUsuario.value);
      this.administradorService
        .setNuevoUsuario(this.formUsuario.value)
        .subscribe({
          next: (resp) => { this.showSuccess(resp.mensaje); this.router.navigate(['/administrador/usuarios']); },
          error: (err) => { console.error(err); }
        });

    } else {
      this.showError('Por favor complete todos los campos requeridos');
      this.markFormGroupTouched(this.formUsuario);
    }
  }
  obtenerInformacion(): void {
    forkJoin({
      subInstituciones: this.administradorService.getInstituciones(),
      subEstados: this.administradorService.getEstados(),
      subEspecialidades: this.administradorService.getEspecialidades(),
      subPuestos: this.administradorService.getPuestos(),
      subRoles: this.administradorService.getRolesPrincipales(),
      subPuntos: this.administradorService.getPuntos(),
      subNiveles: this.administradorService.getNiveles()
    }).subscribe({
      next: (resp) => {
        this.fullCatalogoInstituciones(resp.subInstituciones);
        this.fullCatalogoEstados(resp.subEstados);
        this.fullCatalogoEspecialidades(resp.subEspecialidades);
        this.fullCatalogoPuestos(resp.subPuestos);
        this.fullCatalogoRoles(resp.subRoles);
        this.fullCatalogoPuntos(resp.subPuntos);
        this.fullCatalogoNiveles(resp.subNiveles);
      },
      error: (err) => { console.log(err) }
    });
  }
  fullCatalogoEspecialidades(items: Especialidad[]): void {
    this.especialidades.push(...items);
  }
  fullCatalogoPuestos(items: Catalogo[]): void {
    this.puestos.push(...items);
  }
  fullCatalogoRoles(items: Catalogo[]): void {
    this.roles.push(...items);
  }
  fullCatalogoNiveles(items: Nivel[]): void {
    this.niveles.push(...items);
  }
  fullCatalogoHospitales(items: Hospital[]): void {
    this.hospitales = [];
    this.hospitales.push(...items);
  }
  fullCatalogoInstituciones(instituciones: Institucion[]): void {
    const items: TipoDropdown[] = [...instituciones.map((item: Institucion) => this.institucionToTipoDropdown(item))];
    this.instituciones.push(...items);
  }
  fullCatalogoEstados(estados: Estado[]): void {
    const items: TipoDropdown[] = [...estados.map((item: Estado) => this.estadoToTipoDropdown(item))];
    this.estados.push(...items);
  }
  fullCatalogoPuntos(puntos: Puntos[]): void {
    const items: TipoDropdown[] = [...puntos.map((item: Puntos) => this.puntosToTipoDropdown(item))];
    this.puntos.push(...items);
  }
  institucionToTipoDropdown(institucion: Institucion): TipoDropdown {
    return { value: `${institucion.id}`, label: institucion.cvInstitucion };
  }
  estadoToTipoDropdown(estado: Estado): TipoDropdown {
    return { value: `${estado.id}`, label: estado.nomEstado };
  }
  puntosToTipoDropdown(puntos: Puntos): TipoDropdown {
    return { value: `${puntos.id}`, label: `${puntos.puntos}` };
  }
  createUsuarioFormulario(): FormGroup {
    return this.fb.group({
      // Datos generales del usuario
      usuario: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.maxLength(18)]],
      alias: ['', Validators.required],
      nombre: ['', Validators.required],
      primerApellido: ['', Validators.required],
      segundoApellido: [''],
      telefonoMovil: [''],
      fk_nivel: [4, Validators.required],
      fk_rol: [null, Validators.required],
      activo: [1],

      // Médico
      medico: this.fb.group({
        fk_estado: [''],
        fk_institucion: [''],
        fk_especialidad: [''],
        fk_hospital: [''],
        fk_puesto: [''],
        fk_residencia: [''],
        noConsultorio: [''],
        telefonoMovil: [''],
        telefonoConsultorio: [''],
        hospitalConsultorioPrivado: [''],
        noConsultorioDireccionPrivado: [''],
        nomConsultorioDireccionPrivado: [''],
        telefonoConsultorioPrivado: [''],
        fk_puntos: [1, Validators.required],
        puntos: [500],
        fk_puntos_seg: [1, Validators.required],
        puntos_seg: [500]
      }),

      // Enfermera
      enfermera: this.fb.group({
        puntos: [500],
        fk_puntos: [1],
        fk_supervisor: [null]
      }),

      // Supervisor
      supervisor: this.fb.group({
        correo: [''],
        telefonoMovil: ['']
      })
    });

  }

  confiChange(): void {
    this.formUsuario.get('medico.fk_estado')?.valueChanges.subscribe((value) => { this.getHospitales(); });
    this.formUsuario.get('medico.fk_institucion')?.valueChanges.subscribe((value) => { this.getHospitales(); });
  }

  getHospitales(): void {
    const idInstitucion: number = this.formUsuario.get('medico.fk_institucion')?.value;
    const idEstado: number = this.formUsuario.get('medico.fk_estado')?.value;

    if (idInstitucion && idEstado) {
      this.administradorService.getHospitales(idInstitucion, idEstado).subscribe({
        next: (resp) => {
          this.fullCatalogoHospitales(resp);
        },
        error: (err) => { console.log(err) }
      });
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  cancelar(): void {
    this.router.navigate(['/administrador/usuarios'])
  }
  get f() {
    return this.formUsuario.controls;
  }
}
